<template>
    <div class="knowledge-ranking">
        <div class="knowledge-ranking_title">
            <span>知识考核</span>
        </div>

        <div class="knowledge-ranking_filter">
            <!-- 试卷列表 -->
            <div>
                <el-cascader
                    style="width: 250px; margin-right: 10px"
                    v-model="courseValue"
                    :options="courseOptions"
                    :props="cascProp"
                    @change="handleChapterChange"
                    :show-all-levels="false"
                ></el-cascader>

                <el-select v-model="paper_id" placeholder="请选择" style="width: 250px" class="paper-select" @change="handlePaperChange">
                    <el-option v-for="item in paperList" :key="item.paper_id" :label="item.paper_name" :value="item.paper_id"> </el-option>
                </el-select>
            </div>

            <el-button type="primary" @click="$router.back()">返回</el-button>
        </div>

        <el-scrollbar class="knowledge-ranking_box">
            <div class="personal-ranking_top">
                <template v-if="questionList.length > 0">
                    <div class="top-title">我的答题情况</div>

                    <div class="top-question-list">
                        <div
                            class="question-item"
                            v-for="(item, index) in questionList"
                            :key="item.id"
                            @click="getQuestionDetail(item, index)"
                        >
                            <img src="@/assets/icons/correct-icon.svg" alt="" class="question-result" v-if="item.student_is_true" />
                            <img src="@/assets/icons/fail-icon.svg" alt="" class="question-result" v-else />

                            <div class="question-index">第{{ index + 1 }}题</div>
                        </div>
                    </div>
                </template>

                <div class="box-empty" v-else>
                    <img src="@/assets/images/discussion-empty.png" alt="" />
                    <span>暂无数据</span>
                </div>
            </div>

            <div class="personal-ranking_question" v-if="currentQuestion">
                <div class="question-detail">
                    <!-- 题号 -->
                    <div class="question-detail_index">第{{ questionIndex + 1 }}题：</div>

                    <!-- 题目 -->
                    <div class="question-detail_content">
                        <div class="content-title">{{ getQuestionTitle }}</div>

                        <div class="content-answer">
                            <!-- 单选题 -->
                            <template v-if="[1, 2, 3].includes(currentQuestion.topic_type)">
                                <div class="answer-item" v-for="(answer, index) in getAnswerList" :key="index">{{ answer }}</div>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="question-statictis">
                    <div class="statictis-item current-answer" ref="correntAnswerRef">
                        <span class="statictis-item_label">正确答案：</span>

                        <el-popover
                            placement="top"
                            width="600"
                            trigger="hover"
                            :content="getCorrectAnswer"
                            popper-class="dark-popover"
                            :disabled="!questionAskPoppver"
                        >
                            <span class="statictis-item_value" slot="reference">{{ getCorrectAnswer }}</span>
                        </el-popover>
                    </div>

                    <div class="statictis-item current-answer" ref="studentAnswerRef">
                        <span class="statictis-item_label">学生答案：</span>

                        <el-popover
                            placement="top"
                            width="600"
                            trigger="hover"
                            :content="getStudentAnswer"
                            popper-class="dark-popover"
                            :disabled="!questionStudentPoppver"
                        >
                            <span class="statictis-item_value" slot="reference">{{ getStudentAnswer }}</span>
                        </el-popover>
                    </div>
                </div>
            </div>

            <div class="personal-ranking_bottom">
                <div class="score-item question-type-4" v-for="scoreItem in scoreOptions" :key="scoreItem.key">
                    <div class="score-item_top">
                        <div class="top-label">{{ scoreItem.label }}</div>
                    </div>

                    <div class="score-item_bottom">
                        <el-progress
                            type="circle"
                            :percentage="knowledgeData[scoreItem.key]"
                            :width="100"
                            :stroke-width="8"
                            stroke-linecap="butt"
                            :color="scoreItem.color"
                            :show-text="false"
                        ></el-progress>

                        <div class="progress-text">{{ knowledgeData[scoreItem.key] }}</div>
                    </div>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
export default {
    name: "KnowledgeRanking",
    data() {
        return {
            paper_id: undefined,
            paperList: [],
            scoreOptions: [
                { key: "my_score", label: "我的成绩", color: "#165DFF" },
                { key: "max_score", label: "班级最高分", color: "#4FD1C5" },
                { key: "avg_score", label: "班级平均分", color: "#FEAE65" },
                { key: "min_score", label: "班级最低分", color: "#165DFF" },
            ],
            knowledgeData: {
                my_score: 0, //我的分数
                max_score: 0, //最高分
                min_score: 0, //最低分
                avg_score: 0, //平均分
                topics: {
                    single: [], // 单选题
                    multiple: [], // 多选题
                    judge: [], // 判断题
                    fill_blank: [], // 填空题
                    ask_answer: [], // 问答题
                },
            },
            chartMap: new Map(),
            questionList: [], // 试卷题型类型列表
            questionIndex: 0,
            questionId: undefined,
            currentQuestion: null,
            questionAskPoppver: false,
            questionStudentPoppver: false,
            courseOptions: [],
            courseValue: [],
            cascProp: { label: "name", children: "children", value: "index" },
        };
    },
    created() {
        this.getCourseList();
    },
    mounted() {
        window.addEventListener("resize", this.resizeChart);
    },
    computed: {
        // 获取题目标题
        getQuestionTitle() {
            try {
                const htmlString = this.currentQuestion.topic.title;
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlString, "text/html");

                return doc.body.textContent || doc.body.innerText;
            } catch (error) {
                console.log("question title error: ", error);
                return "";
            }
        },

        // 获取题目学生答案
        getStudentAnswer() {
            const optionsObj = {
                0: "A",
                1: "B",
                2: "C",
                3: "D",
            };
            this.questionStudentPoppver = false;
            if (this.currentQuestion.student_is_answer === 0 || !this.currentQuestion.student_answer) return "学生未作答";

            try {
                if ([1, 3].includes(this.currentQuestion.topic_type)) {
                    // 单选题/判断题
                    return optionsObj[Number(this.currentQuestion.student_answer)];
                } else if (this.currentQuestion.topic_type === 2) {
                    // 多选题
                    let result = "";

                    const answerList = JSON.parse(this.currentQuestion.student_answer);

                    answerList.forEach((item, index) => {
                        if (index !== 0) result += "、";
                        result += optionsObj[item];
                    });

                    return result ? result : "学生未作答";
                } else if (this.currentQuestion.topic_type === 4) {
                    // 填空题
                    let result = "";

                    const answerList = JSON.parse(this.currentQuestion.student_answer);
                    result = (answerList.filter((item) => !!item) || []).join("、");

                    return result ? result : "学生未作答";
                } else if (this.currentQuestion.topic_type === 5) {
                    // 问答题
                    this.$nextTick(() => {
                        this.setStudentAnswerPoppver();
                    });
                    return this.currentQuestion.student_answer || "";
                } else {
                    return "";
                }
            } catch (error) {
                console.log("question correctAnswer error: ", error);
                return "";
            }
        },

        // 获取题目正确答案
        getCorrectAnswer() {
            const optionsObj = {
                0: "A",
                1: "B",
                2: "C",
                3: "D",
            };
            this.questionAskPoppver = false;

            try {
                if ([1, 3].includes(this.currentQuestion.topic_type)) {
                    // 单选题/判断题
                    return optionsObj[this.currentQuestion.topic.options.value];
                } else if (this.currentQuestion.topic_type === 2) {
                    // 多选题
                    let result = "";

                    this.currentQuestion.topic.options.value.forEach((item, index) => {
                        if (index !== 0) result += "、";
                        result += optionsObj[item];
                    });

                    return result;
                } else if (this.currentQuestion.topic_type === 4) {
                    // 填空题
                    let result = "";

                    this.currentQuestion.topic.options.option.forEach((item, index) => {
                        if (index !== 0) result += "、";

                        result += item.name || item || "";
                    });

                    return result;
                } else if (this.currentQuestion.topic_type === 5) {
                    // 问答题
                    this.$nextTick(() => {
                        this.setAnswerPoppver();
                    });
                    return this.currentQuestion.topic.analyse || "";
                } else {
                    return "";
                }
            } catch (error) {
                console.log("question correctAnswer error: ", error);
                return "";
            }
        },

        // 获取题目选项列表
        getAnswerList() {
            try {
                // 单选题
                const answerOptionsWord = ["A", "B", "C", "D", "E", "F", "G", "H"];
                const answerList = [];
                this.currentQuestion.topic.options.option.forEach((item, index) => {
                    answerList.push(`${answerOptionsWord[index]}：${item.name}`);
                });

                return answerList;
            } catch (error) {
                console.error("question answerList error: ", error);
                return [];
            }
        },
    },
    methods: {
        // 获取课程列表
        getCourseList() {
            // /admin/cefinoorsu;
            const params = {
                id: Number(this.$route.query.course_id),
            };

            this.$shttp.axiosGetBy(this.$api.courseContent, params, (res) => {
                if (res.code === 200) {
                    const courseContent = res.data.course_content;
                    this.formatterCourseList(courseContent);

                    this.courseOptions = courseContent;
                    this.courseValue = [0, 0];

                    this.getPaperList();
                }
            });
        },

        formatterCourseList(courseList) {
            for (let i = 0; i < courseList.length; i++) {
                const courseItem = courseList[i];

                if (!!courseItem.id) return false;

                courseItem.index = i;

                if (courseItem.children && courseItem.children.length > 0) {
                    if (!this.formatterCourseList(courseItem.children)) {
                        delete courseItem.children;
                    }
                }
            }

            return true;
        },

        // 获取试卷列表
        getPaperList() {
            if (this.courseValue.length < 2) return;

            const params = {
                c_id: Number(localStorage.getItem("c_id")),
                course_id: Number(this.$route.query.course_id),
                course_chapter: this.courseValue[0],
                course_node: this.courseValue[1],
            };

            this.$shttp.axiosGetBy(this.$api.evaluation_knowledge_paper_list, params, (res) => {
                if (res.code === 200) {
                    this.paperList = res.data.list || [];

                    if (this.paperList.length > 0) {
                        this.paper_id = this.paperList[0].paper_id;

                        this.getKnowledgeData();
                    } else {
                        this.currentQuestion = null;
                        this.questionId = undefined;
                        this.questionIndex = 0;
                        this.paper_id = undefined;
                        this.questionList = [];
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        // 获取知识考核数据
        getKnowledgeData() {
            const params = {
                course_id: Number(this.$route.query.course_id),
                course_chapter: this.courseValue[0],
                course_node: this.courseValue[1],
                paper_id: this.paper_id,
            };

            this.$shttp.axiosGetBy(this.$api.evaluation_answer_detail, params, (res) => {
                if (res.code === 200) {
                    this.knowledgeData = res.data;
                    this.questionList = [];

                    for (const [key, value] of Object.entries(this.knowledgeData.topics)) {
                        if (value.length > 0) {
                            this.questionList.push(...value);
                        }
                    }

                    if (this.questionList.length > 0) {
                        this.currentQuestion = this.questionList[0];
                        this.questionId = this.questionList[0].id;
                        this.questionIndex = 0;

                        console.log("question list: ", this.questionList);
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        handleChapterChange(val) {
            this.courseValue = val;
            this.getPaperList();
        },

        // 获取问题详情-得到当前显示的题目
        getQuestionDetail(question, index) {
            this.questionIndex = index;
            this.currentQuestion = question;
        },

        // 设置popover的状态
        setAnswerPoppver() {
            if (!this.$refs.correntAnswerRef) return;

            const dom = this.$refs.correntAnswerRef;
            this.questionAskPoppver = dom.scrollHeight > dom.clientHeight; // 如果内容大于容器高度。设置悬浮框可见
        },

        setStudentAnswerPoppver() {
            if (!this.$refs.studentAnswerRef) return;

            const dom = this.$refs.studentAnswerRef;
            this.questionAskPoppver = dom.scrollHeight > dom.clientHeight; // 如果内容大于容器高度。设置悬浮框可见
        },

        handlePaperChange(val) {
            this.paper_id = val;
            this.getKnowledgeData();
        },

        resizeChart() {
            for (const [_, value] of this.chartMap) {
                value.resize();
            }
        },
    },

    destroyed() {
        window.removeEventListener("resize", this.resizeChart);
    },
};
</script>

<style lang="scss" scoped>
::v-deep .bar-tooltip {
    padding: 14px;
    color: #333333;

    .tooltip-item {
        &:not(.tooltip-item:last-of-type) {
            margin-bottom: 10px;
        }

        &_title {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
        }

        &_score {
            min-width: 130px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            // gap: 70px;
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
        }
    }
}

.knowledge-ranking {
    width: 100%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    background-color: #efefef;

    &_title {
        font-family: PingFang-SC, PingFang-SC;
        height: 24px;
        font-weight: 800;
        font-size: 24px;
        color: #333333;
        line-height: 24px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &_filter {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        .el-button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 88px;
            height: 36px;
        }

        ::v-deep .el-input__inner {
            background-color: #ffffff !important;
        }
    }

    &_box {
        height: calc(100vh - 252px);
        // background-color: #ffffff;

        ::v-deep .el-scrollbar__wrap {
            margin: 0 !important;

            &::-webkit-scrollbar {
                display: none;
            }
        }

        .score-item {
            height: 200px;
            width: calc((100% - 48px) / 4);
            background-color: #ffffff;
            border-radius: 8px;
            box-sizing: border-box;
            padding: 24px;
            overflow: hidden;

            &_top {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .top-label {
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #000000;
                    flex-shrink: 0;
                }

                .top-enter {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    cursor: pointer;

                    img {
                        width: 16px;
                        height: 16px;
                        object-fit: cover;
                    }

                    span {
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #006eff;
                        flex-shrink: 0;
                    }
                }
            }

            &_bottom {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 20px;
                position: relative;

                .progress-text {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 600;
                    font-size: 36px;
                    color: #000000;
                }
            }
        }

        .personal-ranking {
            height: calc(100vh - 252px);
            width: 100%;
            box-sizing: border-box;

            &_top {
                height: calc(100% - 306px);
                background-color: #ffffff;
                border-radius: 8px;
                box-sizing: border-box;
                padding: 24px;

                .top-title {
                    height: 24px;
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #26292e;
                    line-height: 24px;
                    margin-bottom: 20px;
                }

                .top-chart {
                    height: calc(100% - 74px);
                    // background-color: lightgray;
                }

                .top-question-list {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 13px 20px;

                    .question-item {
                        width: 95px;
                        height: 105px;
                        background-color: #f4f8f7;
                        border-radius: 8px;
                        box-sizing: border-box;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 20px;
                        flex-direction: column;
                        cursor: pointer;

                        img {
                            width: 23px;
                            height: 23px;
                            object-fit: cover;
                        }

                        .question-index {
                            height: 20px;
                            font-family: PingFang-SC, PingFang-SC;
                            font-weight: bold;
                            font-size: 16px;
                            color: #858585;
                            line-height: 20px;
                            letter-spacing: 2px;
                        }
                    }
                }

                .box-empty {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    gap: 20px;

                    span {
                        height: 20px;
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        line-height: 16px;
                    }
                }
            }

            &_question {
                padding: 24px;
                background-color: #ffffff;
                border-radius: 8px;
                margin-top: 20px;

                .question-detail {
                    display: flex;

                    &_index,
                    &_content .content-title {
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;
                        line-height: 20px;
                        letter-spacing: 2px;
                    }

                    &_index {
                        flex-shrink: 0;
                    }

                    &_content {
                        .content-title {
                            font-weight: 600;

                            & > * {
                                margin: 0 !important;
                                padding: 0 !important;
                            }
                        }

                        .content-answer {
                            .answer-item {
                                height: 20px;
                                font-family: PingFang-SC, PingFang-SC;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                line-height: 20px;
                                letter-spacing: 2px;
                                margin-top: 10px;

                                &:first-of-type {
                                    margin-top: 20px;
                                }
                            }
                        }
                    }
                }

                .question-statictis {
                    margin-top: 20px;
                    padding: 10px 16px;
                    background-color: #fcfcfc;
                    border-radius: 4px;
                    display: flex;
                    align-items: flex-start;
                    gap: 40px;

                    .statictis-item {
                        // height: 25px;
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        line-height: 25px;
                        flex-shrink: 0;

                        &.current-answer {
                            max-width: calc((100% - 40px) / 2);

                            display: -webkit-box; /* 创建一个弹性盒子 */
                            -webkit-box-orient: vertical; /* 设置主轴为纵向 */
                            -webkit-line-clamp: 4; /* 限制显示4行 */
                            line-clamp: 4;
                            overflow: hidden; /* 隐藏多余的内容 */
                            text-overflow: ellipsis; /* 显示省略号 */
                            word-break: break-all;
                        }
                    }
                }
            }

            &_bottom {
                height: 200px;
                margin-top: 20px;
                display: flex;
                gap: 16px;
            }
        }
    }
}
</style>
